// importing from sprinklr/modules wasn't working, so I copied this here for now
export const EMPTY_ARRAY_READONLY: any = Object.freeze([]);
